import React from "react";

export default function Down() {
  return <i className="fas fa-chevron-down" />;
}
